module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d4c001a5348e8e71237438ccd8b4cd9f.png";